import styled from "styled-components";

export const Table = styled.table`
  border: var(--light-blue) 2px solid;
  width: 100%;
  ${props => props.type == 'm' ? 'margin-bottom: 20px;' : 'margin-bottom: 5px;'}

  td,
  th {
    border: var(--light-blue) 1px solid;
    text-align: center;
  }

  th {
    background-color: var(--light-fake-blue);
  }
`;
